export function toMinutes(t: string): number {
  const [h, m] = t.split(':').map(Number);
  return (h ?? 0) * 60 + (m ?? 0);
}

export function overlaps(entryStart: string, entryEnd: string, slotHour: number): boolean {
  const start = toMinutes(entryStart);
  const end = toMinutes(entryEnd);
  const slotStart = slotHour * 60;
  const slotEnd = slotStart + 60;
  return start < slotEnd && end > slotStart;
}

export interface ParsedFreeTimeSlot {
  /** Lowercase day key (e.g. "monday") — matches student_timetable.days_full's keys. */
  day: string;
  start: string;
  end: string;
}

/** Parses a "day HH:MM–HH:MM" free-time-slot string as returned by the AI
 * proposal engine (e.g. "friday 08:00–08:15") into its parts, so callers can
 * translate the day name and format the time range instead of showing the
 * raw, lowercase, untranslated string as-is. Returns null for anything that
 * doesn't match — callers should fall back to displaying the raw string. */
export function parseFreeTimeSlot(slot: string): ParsedFreeTimeSlot | null {
  const match = slot.trim().match(/^([a-zA-Z]+)\s+(\d{1,2}:\d{2})\s*[–—-]\s*(\d{1,2}:\d{2})$/);
  if (!match) return null;
  const [, day, start, end] = match;
  return { day: (day ?? '').toLowerCase(), start: start ?? '', end: end ?? '' };
}
